import React, { useState } from 'react';
import axios from 'axios';
import BASE_URL from '../../../config/config';
import { useNavigate } from 'react-router-dom';
import ModuleService from '../../Setup/controller/ModuleController/ModuleController';
import FormService from '../../Setup/controller/FormController/FormController';
import ClientLanguages from '../../Setup/controller/LanguageController/LanguageController';
import HelpLinkService from '../../SuperAdmin/Controller/Configuration/HelpLinkController';
import UserService from '../../Setup/controller/UserController/UserController';
import axiosInstance from '../../../config/axiosInstance';
const VerifyOtp = () => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isResending, setIsResending] = useState(false);
  const navigate = useNavigate();

  const email = localStorage.getItem('pendingEmail');

  const redirectCallback = () => navigate('/');

  // ✅ same logic as navigateUser()
  const navigateUser = async (response) => {
    const user = response.data.companies[0];
    const redirectCallback = () => navigate('/');
    localStorage.setItem('token', response.data.token);
    localStorage.setItem('refreshToken', response.data.refreshToken);
    localStorage.setItem('CompanyID', user.HostCompanyID);
    localStorage.setItem('RoleID', user.RolesID);
    localStorage.setItem('UserID', user.UserID);
    localStorage.setItem('DisplayName', user.DisplayName);
    localStorage.setItem('Email', user.UserName);
    localStorage.setItem('UserName', user.Email);
    localStorage.setItem('CompanyName', user.CompanyName);
    localStorage.setItem('Address1', user.Address1);
    localStorage.setItem('ContractPrefix', user.ContractPrefix);
    localStorage.setItem('AllowedUsers', user.AllowedUsers);
    localStorage.setItem('RoleName', user.RoleName);
    localStorage.setItem('EmailFooter', user.EmailFooter);

    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;



    const ModuleList = await ModuleService.GetAllModules(redirectCallback, 'en');
    localStorage.setItem('ModuleList', JSON.stringify(ModuleList));

    const FormList = await FormService.GetAllForms(redirectCallback);
    localStorage.setItem('FormList', JSON.stringify(FormList));

    const clientLanguage = await ClientLanguages.GetClientLanguage(redirectCallback, user.HostCompanyID);
    localStorage.setItem('ClientLanguages', JSON.stringify(clientLanguage));

    const HelpLink = await HelpLinkService.GetAllHelpLinks(redirectCallback);
    if (HelpLink && HelpLink[0]) {
      localStorage.setItem('HelpLink', HelpLink[0].HelpLink);
    }

    const userCompanies = await UserService.IsMultipleCompanies(user.Email);
    localStorage.setItem('Companies', JSON.stringify(userCompanies));
    localStorage.setItem('MultipleCompanies', userCompanies.length > 1 ? '1' : '0');

    navigate('/Dashboard');
  };

  const handleVerify = async () => {
    setError('');
    try {
      debugger;
      const response = await axios.post(`${BASE_URL}/Auth/verify-otp`, { email, otp });
      if (response.data.message === 'OTP verified successfully') {
        await navigateUser(response); // 👈 reuse your same login logic
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'OTP verification failed');
    }
  };

  const handleResend = async () => {
    setIsResending(true);
    setError('');
    setMessage('');
    try {
      const response = await axios.post(`${BASE_URL}/Auth/resend-otp`, { email });
      setMessage(response.data.message || 'OTP resent successfully.');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to resend OTP.');
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="auth-main-content auth-bg-image">
      <div className="d-table">
        <div className="d-tablecell">
          <div className="auth-box">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="form-content">
                  <div className="auth-logo">
                    <img src="assets/img/logo.png" alt="Logo" style={{ width: "70%" }} />
                  </div>

                  <h1 className="heading">Email OTP Verification</h1>
                  <p className="text-center text-danger small">
                    OTP sent to <b>{email}</b>
                  </p>

                  <input
                    type="text"
                    className="form-control text-center"
                    placeholder="Enter 6-digit OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    maxLength={6}
                  />

                  <button onClick={handleVerify} className="btn btn-primary btn-block mt-3">
                    Verify OTP
                  </button>

                  <button
                    onClick={handleResend}
                    className="btn btn-link small mt-2"
                    disabled={isResending}
                  >
                    {isResending ? 'Resending...' : 'Resend OTP'}
                  </button>

                  {error && <p className="text-danger mt-2">{error}</p>}
                  {message && <p className="text-success mt-2">{message}</p>}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default VerifyOtp;
